import React from 'react';
import _ from 'lodash';
import { Table, TableRow, TableRowColumn, TableBody, TableHeaderColumn, TableHeader } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

class Cells extends React.Component {
    constructor(props) {
        super(props);

        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
    }

    add() {
        const cells = _.cloneDeep(this.props.cells);

        cells.push({
            holds: {
                l: '',
                b: '',
                h: '',
                area: '',
            },
            tweenDecks: [
                { l: '', b: '', h: '', area: '' },
                { l: '', b: '', h: '', area: '' },
            ],
            hatches: [
                { l: '', b: '', area: '' },
                { l: '', b: '', area: '' },
            ],
        });

        this.props.changeField({
            field: 'cells',
            value: cells,
        });
    }

    remove(index) {
        const cells = _.cloneDeep(this.props.cells);
        cells.splice(index, 1);
        this.props.changeField({
            field: 'cells',
            value: cells,
        });
    }

    render() {
        const { getError, confirmed, changeField, changeAreas, cells, modifiedFields, underStyle } = this.props;

        const tableItemHolds = (stateName, index) => {
            return (
                <NumberField
                    name={`cells[${index}][holds].${stateName}`}
                    value={cells[index]['holds'] ? cells[index]['holds'][stateName] : ''}
                    disabled={confirmed}
                    errorText={getError(`cells[${index}][holds].${stateName}`)}
                    floatNumber
                    min={0}
                    style={{width: '3em'}}
                    onChange={(e, value) => {
                        changeField({
                            field: `cells[${index}][holds].${stateName}`,
                            value,
                        });
                    }}
                    underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][holds].${stateName}`) ? underStyle : null}
                />
            );
        };

        const tableItemTweenHatch = (stateName, stateNameArrIndex, dimensionName, index) => {
            return (
                <NumberField
                    name={`cells[${index}][${stateName}][${stateNameArrIndex}].${dimensionName}`}
                    value={
                        cells[index][stateName][stateNameArrIndex] ? 
                            cells[index][stateName][stateNameArrIndex][dimensionName] : ''
                    }
                    disabled={confirmed}
                    errorText={getError(`cells[${index}][${stateName}][${stateNameArrIndex}].${dimensionName}`)}
                    floatNumber
                    min={0}
                    style={{width: '3em'}}
                    onChange={(e, value) => {
                        changeField({
                            field: `cells[${index}][${stateName}][${stateNameArrIndex}].${dimensionName}`,
                            value,
                        });
                    }}
                    underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][${stateName}][${stateNameArrIndex}].${dimensionName}`) ? underStyle : null}
                />
            );
        };

        return (
            <React.Fragment>
                <Table
                    showCheckboxes={false}
                    selectable={false}
                    style={{ border: '1px solid #DFDFDF' }}
                >
                    <TableHeader
                        adjustForCheckbox={false}
                        displaySelectAll={false}
                    >
                        <TableRow >
                            <TableHeaderColumn>
                                <div style={{ margin: '0 0 0 155px' }}>
                                    Holds
                                </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                <div style={{ margin: '0 0 0 115px' }}>
                                    Tweendecks
                                </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                <div style={{ margin: '0 0 0 70px' }}>
                                    Hatches
                                </div>
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody
                        displayRowCheckbox={false}
                    >
                        <TableRow>
                            <TableHeaderColumn style={{ paddingLeft:'13px' }}>Cell No</TableHeaderColumn>
                            <TableHeaderColumn style={{borderLeft: '1px solid #DEDEDE', paddingLeft:'25px'}}>L, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'25px'}}>B, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'20px'}}>H, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'10px'}}>Area, m2</TableHeaderColumn>
                            <TableHeaderColumn style={{borderLeft: '1px solid #DEDEDE'}}>L, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'13px'}}>B, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'13px'}}>H, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'13px'}}>Area, m2</TableHeaderColumn>
                            <TableHeaderColumn style={{borderLeft: '1px solid #DEDEDE'}}>L, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'13px'}}>B, m</TableHeaderColumn>
                            <TableHeaderColumn style={{padding:'13px' }}>Area, m2</TableHeaderColumn>
                            <TableHeaderColumn style={{borderLeft: '1px solid #DEDEDE', paddingLeft:'13px'}} />
                        </TableRow>

                        {
                            cells.map((item, index) => {
                                return (
                                    <TableRow
                                        key={index}
                                    >
                                        <TableRowColumn>
                                            <div style={{ margin: '25px 0 0 0' }}>
                                                {index + 1}
                                            </div>
                                        </TableRowColumn>
                                        <TableRowColumn style={{borderLeft: '1px solid #DEDEDE', padding:'13px'}}>
                                            {tableItemHolds('l', index)}
                                        </TableRowColumn>
                                        <TableRowColumn style={{padding:'13px'}}>
                                            {tableItemHolds('b', index)}
                                        </TableRowColumn>
                                        <TableRowColumn style={{padding:'13px'}}>
                                            {tableItemHolds('h', index)}
                                        </TableRowColumn>
                                        <TableRowColumn style={{padding:'10px'}}>
                                            <NumberField
                                                name={`cells[${index}][holds]area`}
                                                value={cells[index].holds ? cells[index].holds.area : ''}
                                                disabled={confirmed}
                                                errorText={getError(`cells[${index}][holds]area`)}
                                                floatNumber
                                                style={{width: '3em'}}
                                                min={0}
                                                onChange={(e, value) => {
                                                    changeAreas({
                                                        field: `cells[${index}][holds].area`, 
                                                        value 
                                                    });
                                                    changeField({
                                                        field: `cells[${index}][holds].area`,
                                                        value,
                                                    });
                                                }}
                                                underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][holds].area`) ? underStyle : null}
                                            />
                                        </TableRowColumn>
                                        <TableRowColumn style={{borderLeft: '1px solid #DEDEDE', paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>{tableItemTweenHatch('tweenDecks', 0, 'l', index)}</td></tr>
                                                    <tr><td>{tableItemTweenHatch('tweenDecks', 1, 'l', index)}</td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>{tableItemTweenHatch('tweenDecks', 0, 'b', index)}</td></tr>
                                                    <tr><td>{tableItemTweenHatch('tweenDecks', 1, 'b', index)}</td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>{tableItemTweenHatch('tweenDecks', 0, 'h', index)}</td></tr>
                                                    <tr><td>{tableItemTweenHatch('tweenDecks', 1, 'h', index)}</td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>
                                                        <NumberField
                                                            name={`cells[${index}][tweenDecks][0].area`}
                                                            value={cells[index].tweenDecks[0] ? 
                                                                cells[index].tweenDecks[0].area : ''
                                                            }
                                                            disabled={confirmed}
                                                            errorText={getError(`cells[${index}][tweenDecks][0].area`)}
                                                            floatNumber
                                                            min={0}
                                                            style={{width: '3em'}}
                                                            onChange={(e, value) => {
                                                                changeAreas({ 
                                                                    field: `cells[${index}][tweenDecks][0].area`, 
                                                                    value 
                                                                });

                                                                changeField({
                                                                    field: `cells[${index}][tweenDecks][0].area`,
                                                                    value,
                                                                });
                                                            }}
                                                            underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][tweenDecks][0].area`) ? underStyle : null}
                                                        />
                                                    </td></tr>
                                                    <tr><td>
                                                        <NumberField
                                                            name={`cells[${index}][tweenDecks][1].area`}
                                                            value={cells[index].tweenDecks[1] ? 
                                                                cells[index].tweenDecks[1].area : ''
                                                            }
                                                            disabled={confirmed}
                                                            errorText={getError(`cells[${index}][tweenDecks][1].area`)}
                                                            floatNumber
                                                            min={0}
                                                            style={{width: '3em'}}
                                                            onChange={(e, value) => {
                                                                changeAreas({ 
                                                                    field: `cells[${index}][tweenDecks][1].area`, 
                                                                    value 
                                                                });
                                                                changeField({
                                                                    field: `cells[${index}][tweenDecks][1].area`,
                                                                    value,
                                                                });
                                                            }}
                                                            underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][tweenDecks][1].area`) ? underStyle : null}
                                                        />
                                                    </td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{borderLeft: '1px solid #DEDEDE', paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>{tableItemTweenHatch('hatches', 0, 'l', index)}</td></tr>
                                                    <tr><td>{tableItemTweenHatch('hatches', 1, 'l', index)}</td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>{tableItemTweenHatch('hatches', 0, 'b', index)}</td></tr>
                                                    <tr><td>{tableItemTweenHatch('hatches', 1, 'b', index)}</td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{paddingLeft:'13px'}}>
                                            <table>
                                                <tbody>
                                                    <tr><td>
                                                        <NumberField
                                                            name={`cells[${index}][hatches][0].area`}
                                                            value={cells[index].hatches[0] ? cells[index].hatches[0].area : ''}
                                                            disabled={confirmed}
                                                            errorText={getError(`cells[${index}][hatches][0].area`)}
                                                            floatNumber
                                                            min={0}
                                                            style={{width: '3em'}}
                                                            onChange={(e, value) => {
                                                                changeAreas({ 
                                                                    field: `cells[${index}][hatches][0].area`, 
                                                                    value,
                                                                    hatchesField: true,
                                                                });
                                                                changeField({
                                                                    field: `cells[${index}][hatches][0].area`,
                                                                    value,
                                                                });
                                                            }}
                                                            underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][hatches][0].area`) ? underStyle : null}
                                                        />
                                                    </td></tr>
                                                    <tr><td>
                                                        <NumberField
                                                            name={`cells[${index}][hatches][1].area`}
                                                            value={cells[index].hatches[1] ? cells[index].hatches[1].area : ''}
                                                            disabled={confirmed}
                                                            errorText={getError(`cells[${index}][hatches][1].area`)}
                                                            floatNumber
                                                            min={0}
                                                            style={{width: '3em'}}
                                                            onChange={(e, value) => {
                                                                changeAreas({ 
                                                                    field: `cells[${index}][hatches][1].area`, 
                                                                    value,
                                                                    hatchesField: true,
                                                                });
                                                                changeField({
                                                                    field: `cells[${index}][hatches][1].area`,
                                                                    value,
                                                                });
                                                            }}
                                                            underlineStyle={modifiedFields && modifiedFields.includes(`cells[${index}][hatches][1].area`) ? underStyle : null}

                                                        />
                                                    </td></tr>
                                                </tbody>
                                            </table>
                                        </TableRowColumn>
                                        <TableRowColumn style={{borderLeft: '1px solid #DEDEDE', paddingRight:'2em'}}>
                                            {
                                                !index ?
                                                    <IconButton>
                                                        <ContentAddIcon
                                                            onClick={() => {
                                                                this.add();
                                                            }}
                                                            style={{ margin: '70px 0 0 0' }}
                                                            color='green'
                                                        />
                                                    </IconButton>
                                                    :
                                                    <IconButton>
                                                        <ContentRemoveIcon
                                                            onClick={() => {
                                                                this.remove(index);
                                                            }}
                                                            style={{ margin: '30px 0 0 0' }}
                                                            color='red'
                                                        />
                                                    </IconButton>
                                            }
                                        </TableRowColumn>
                                    </TableRow>
                                );
                            })
                        }


                    </TableBody>
                </Table>
            </React.Fragment>
        );
    }
}

export default Cells;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Cells.jsx